// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__jBHuA","consentsList":"PatientConsents_consentsList__2-i6a","consentsListEmpty":"PatientConsents_consentsListEmpty__38IKG"};